import * as React from "react"
import { forwardRef, memo } from "react"

const SvgComponent = (props, ref) => (
  <svg
    width={28}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M3.111 14.768 0 1.23l8.556 6.153L14 0l5.444 7.384L28 1.231l-3.111 13.537H3.11Z"
      fill="#FFE925"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgComponent)
const Memo = memo(ForwardRef)
export default Memo
